import SortMixin from './SortMixin'
import FilterMixin from './FilterMixin'
import DefaultValuesMixin from './DefaultValues'
import GenericListMixin from './GenericListMixin'
import OptionStatusMixin from './OptionStatusMixin'
import DenunciationStatusMixin from './DenunciationStatusMixin'
import DownloadFileMixin from './DownloadFileMixin'
import ErrorMixin from './ErrorMixin'
import ColumnConfMixin from './ColumnConfMixin'
import OriginRowMixin from './OriginRowMixin'
import MultiSelectionMixin from './MultiSelectionMixin'
import EntityMixin from './EntityMixin'
import CalendarMixin from './CalendarMixin'
import CalendarDayMixin from './CalendarDayMixin'
import AdvMixin from './AdvMixin'
import StatsMixin from './StatsMixin'
import EventTrackerMixin from './EventTrackerMixin'
import TableHeaderStickyMixin from './TableHeaderStickyMixin'
import GoogleMixin from './GoogleMixin'
import StatsPeriodMixin from './StatsPeriodMixin'
import StatsStickyMixin from './StatsStickyMixin'

export const EntityMx = EntityMixin
export const Sort = SortMixin
export const Filter = FilterMixin
export const DefaultValues = DefaultValuesMixin
export const GenericList = GenericListMixin
export const OptionStatus = OptionStatusMixin
export const DenunciationStatus = DenunciationStatusMixin
export const DownloadFile = DownloadFileMixin
export const Error = ErrorMixin
export const ColumnConf = ColumnConfMixin
export const OriginRowMx = OriginRowMixin
export const MultiSelection = MultiSelectionMixin
export const CalendarMx = CalendarMixin
export const CalendarDayMx = CalendarDayMixin
export const AdvMx = AdvMixin
export const StatsMx = StatsMixin
export const EventTrackerMx = EventTrackerMixin
export const TableHeaderSticky = TableHeaderStickyMixin
export const GoogleMx = GoogleMixin
export const StatsPeriodMx = StatsPeriodMixin
export const StatsStickyMx = StatsStickyMixin



// WEBPACK FOOTER //
// ./src/mixins/index.js